import { Badge } from '@/components/ui/badge';
import { UserRole, ROLE_LABELS, ROLE_BADGE_VARIANTS } from '@/types/user';

interface RoleBadgeProps {
  role: UserRole;
  className?: string;
}

export function RoleBadge({ role, className }: RoleBadgeProps) {
  const label = ROLE_LABELS[role] || role;
  const badgeConfig = ROLE_BADGE_VARIANTS[role] || { variant: 'outline' as const };

  return (
    <Badge
      variant={badgeConfig.variant}
      className={`${badgeConfig.className || ''} ${className || ''}`}
    >
      {label}
    </Badge>
  );
}
